import Swiper from 'swiper/bundle';

// primary section
function primaryAccordionImage() {
    // why kids section accordion images
    const collapseButton = document.querySelectorAll('.primary__collapse-button');
    collapseButton.forEach(item => {
        // select image element
        const imageElement = document.querySelector('.primary__image');

        item.addEventListener('click', event => {
            // get data image index attribute
            const imageUrl = item.getAttribute("data-image");

            // pass value into image element
            imageElement.src = imageUrl;
        });
    });
}

// jenaplan section
function jenaplanHover() {
    const jenaplanItems = document.querySelectorAll('.jenaplan__item');
    jenaplanItems.forEach(e => {
        
        e.addEventListener('mouseenter', () => {
            const jenaplanTitle = e.querySelector('.jenaplan__title');
            let jenaplanDescription = e.querySelector('.jenaplan__content').offsetHeight;
            
            jenaplanItems.forEach(f => {
                f.classList.remove('jenaplan-active');
            })
            e.classList.add('jenaplan-active');
        })
    })
}

// project base learning
var pblSwiperImage = new Swiper(".pbl__swiper", {
    slidesPerView: 1,
    spaceBetween: 15,
    allowTouchMove: true,
    speed: 800,
    autoplay: false,
    pagination: {
        el: ".pbl__swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        576: {
            slidesPerView: 1.5,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: "auto",
            spaceBetween: 20,
        },
    },
});
// pbl section dynamic height on window resize
function dynamicHeightPbl() {
    const pblSwiperHeight = document.querySelector('.pbl__swiper').offsetHeight;
    const pblDescriptionRow = document.querySelector('.pbl .row');
    pblDescriptionRow.style.minHeight = pblSwiperHeight + 'px';
}

function holidaySwiper() {
    const swiper = new Swiper('.holiday__swiper', {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
         // Navigation arrows
        navigation: {
            nextEl: '.holiday__swiper .swiper-button-next',
            prevEl: '.holiday__swiper .swiper-button-prev',
        },
    })
}

document.addEventListener("DOMContentLoaded", function () {
    primaryAccordionImage()
    jenaplanHover();
    dynamicHeightPbl();
    holidaySwiper()
})

window.addEventListener('resize', function (event) {
    dynamicHeightPbl();
})